// Generated by purs version 0.15.15
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Ouroboros_Models_Brands_ErrorMessageText from "../Ouroboros.Models.Brands.ErrorMessageText/index.js";
import * as Ouroboros_Models_Brands_HttpStatusCode from "../Ouroboros.Models.Brands.HttpStatusCode/index.js";
import * as Ouroboros_Models_Clients_Payment from "../Ouroboros.Models.Clients.Payment/index.js";
import * as Ouroboros_Models_Core_Ok from "../Ouroboros.Models.Core.Ok/index.js";
import * as Ouroboros_Programs_Controllers_JwtSession from "../Ouroboros.Programs.Controllers.JwtSession/index.js";
import * as Ouroboros_Services_FFI_Env from "../Ouroboros.Services.FFI.Env/index.js";
import * as Ouroboros_Services_FFI_Http from "../Ouroboros.Services.FFI.Http/index.js";
import * as Ouroboros_Services_FFI_TaskEither from "../Ouroboros.Services.FFI.TaskEither/index.js";
import * as Ouroboros_Services_FFI_Uuid from "../Ouroboros.Services.FFI.Uuid/index.js";
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var validationError = function (message) {
    return {
        type: "ValidationError",
        message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText(message),
        statusCode: Data_Maybe.Nothing.value
    };
};
var unauthorizedError = /* #__PURE__ */ (function () {
    return {
        type: "Unauthorized",
        message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Unauthorized"),
        statusCode: Data_Maybe.Nothing.value
    };
})();
var traceHeaders = function (headers) {
    return Ouroboros_Services_FFI_Http.mkHeaders(append(headers)([ new Data_Tuple.Tuple("X-Trace-ID", Ouroboros_Services_FFI_Uuid.uuidV7(Data_Unit.unit)) ]));
};
var serverError = function (status) {
    return {
        type: "ServerError",
        message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Server responded with an error: " + show(status)),
        statusCode: new Data_Maybe.Just(Ouroboros_Models_Brands_HttpStatusCode.makeHttpStatusCode(Data_Int.toNumber(status)))
    };
};
var parseJson = function (response) {
    return Ouroboros_Services_FFI_TaskEither.tryCatch(function (v) {
        return Ouroboros_Services_FFI_Http.responseJson(response);
    })(function (v) {
        return {
            type: "ValidationError",
            message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Response validation failed"),
            statusCode: Data_Maybe.Nothing.value
        };
    });
};
var networkError = /* #__PURE__ */ (function () {
    return {
        type: "NetworkError",
        message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Failed to connect to the server. Please check your internet connection."),
        statusCode: Data_Maybe.Nothing.value
    };
})();
var handleResponse = function (response) {
    return function (decoder) {
        return function (message) {
            var $10 = Ouroboros_Services_FFI_Http.responseOk(response);
            if ($10) {
                return Ouroboros_Services_FFI_TaskEither.chain(parseJson(response))(function (payload) {
                    var v = decoder(payload);
                    if (v instanceof Data_Either.Left) {
                        return Ouroboros_Services_FFI_TaskEither.left(validationError(message));
                    };
                    if (v instanceof Data_Either.Right) {
                        return Ouroboros_Services_FFI_TaskEither.right(v.value0);
                    };
                    throw new Error("Failed pattern match at Ouroboros.Services.Ouroboros.Payment (line 88, column 9 - line 90, column 44): " + [ v.constructor.name ]);
                });
            };
            return Ouroboros_Services_FFI_TaskEither.left(serverError(Ouroboros_Services_FFI_Http.responseStatus(response)));
        };
    };
};
var fetchWithTrace = function (onUnauthorized) {
    return function (url) {
        return function (init) {
            return Ouroboros_Services_FFI_TaskEither.chain(Ouroboros_Services_FFI_TaskEither.tryCatch(function (v) {
                return Ouroboros_Services_FFI_Http.fetch_(url)(init);
            })(function (v) {
                return networkError;
            }))(function (response) {
                var $14 = Ouroboros_Services_FFI_Http.responseStatus(response) === 401;
                if ($14) {
                    return Ouroboros_Services_FFI_TaskEither.chain(Ouroboros_Services_FFI_TaskEither.fromIO(Ouroboros_Programs_Controllers_JwtSession.actionEffect(onUnauthorized)))(function (v) {
                        return Ouroboros_Services_FFI_TaskEither.left(unauthorizedError);
                    });
                };
                return Ouroboros_Services_FFI_TaskEither.right(response);
            });
        };
    };
};
var createDefaultPaymentClient = function (onUnauthorized) {
    return {
        getPublishableKey: Ouroboros_Services_FFI_TaskEither.map(function (validation) {
            return validation.stripe_publishable_key;
        })(Ouroboros_Services_FFI_TaskEither.chain(fetchWithTrace(onUnauthorized)(Ouroboros_Services_FFI_Env.apiUrl + "/v1/public-keys/stripe-publishable-key")(Ouroboros_Services_FFI_Http.requestInitNoBody("GET")(traceHeaders([ new Data_Tuple.Tuple("Content-Type", "application/json") ]))))(function (response) {
            return handleResponse(response)(Ouroboros_Models_Clients_Payment.decodeGetPublishableKeyResponse)("Invalid publishable key payload");
        })),
        setupIntent: function (subscriptionPlan) {
            return Ouroboros_Services_FFI_TaskEither.map(function (validation) {
                return validation.setup_intent_secret;
            })(Ouroboros_Services_FFI_TaskEither.chain(fetchWithTrace(onUnauthorized)(Ouroboros_Services_FFI_Env.apiUrl + "/v1/payments/setup-intent")(Ouroboros_Services_FFI_Http.requestInitJson("POST")(traceHeaders([ new Data_Tuple.Tuple("Content-Type", "application/json") ]))(Foreign.unsafeToForeign({
                subscription_plan: subscriptionPlan
            }))))(function (response) {
                return handleResponse(response)(Ouroboros_Models_Clients_Payment.decodeSetupIntentResponse)("Invalid setup intent payload");
            }));
        },
        cancelSubscription: Ouroboros_Services_FFI_TaskEither.chain(fetchWithTrace(onUnauthorized)(Ouroboros_Services_FFI_Env.apiUrl + "/v1/payments/cancel-subscription")(Ouroboros_Services_FFI_Http.requestInitNoBody("POST")(traceHeaders([ new Data_Tuple.Tuple("Content-Type", "application/json") ]))))(function (response) {
            var $15 = Ouroboros_Services_FFI_Http.responseOk(response);
            if ($15) {
                return Ouroboros_Services_FFI_TaskEither.right(Ouroboros_Models_Core_Ok.ok);
            };
            return Ouroboros_Services_FFI_TaskEither.left(serverError(Ouroboros_Services_FFI_Http.responseStatus(response)));
        }),
        validatePromoCode: function (promoCode) {
            return Ouroboros_Services_FFI_TaskEither.chain(fetchWithTrace(onUnauthorized)(Ouroboros_Services_FFI_Env.apiUrl + "/v1/trial-activation/validate-promo-code")(Ouroboros_Services_FFI_Http.requestInitJson("POST")(traceHeaders([ new Data_Tuple.Tuple("Content-Type", "application/json") ]))(Foreign.unsafeToForeign({
                promo_code: promoCode
            }))))(function (response) {
                return handleResponse(response)(Ouroboros_Models_Clients_Payment.decodePromoCodeResponse)("Invalid promo code payload");
            });
        },
        submitDemographicInformation: function (promoCode) {
            return function (demographicInfo) {
                return Ouroboros_Services_FFI_TaskEither.chain(fetchWithTrace(onUnauthorized)(Ouroboros_Services_FFI_Env.apiUrl + "/v1/trial-activation/activate-trial")(Ouroboros_Services_FFI_Http.requestInitJson("POST")(traceHeaders([ new Data_Tuple.Tuple("Content-Type", "application/json") ]))(Foreign.unsafeToForeign({
                    promo_code: promoCode,
                    demographic_info: demographicInfo
                }))))(function (response) {
                    var $16 = Ouroboros_Services_FFI_Http.responseOk(response);
                    if ($16) {
                        return Ouroboros_Services_FFI_TaskEither.right(Ouroboros_Models_Core_Ok.ok);
                    };
                    return Ouroboros_Services_FFI_TaskEither.left(serverError(Ouroboros_Services_FFI_Http.responseStatus(response)));
                });
            };
        },
        submitSquareCardNonce: function (nonce) {
            return Ouroboros_Services_FFI_TaskEither.chain(fetchWithTrace(onUnauthorized)(Ouroboros_Services_FFI_Env.apiUrl + "/v1/payments/payment-method")(Ouroboros_Services_FFI_Http.requestInitJson("POST")(traceHeaders([ new Data_Tuple.Tuple("Content-Type", "application/json") ]))(Foreign.unsafeToForeign({
                nonce: nonce
            }))))(function (response) {
                var $17 = Ouroboros_Services_FFI_Http.responseOk(response);
                if ($17) {
                    return Ouroboros_Services_FFI_TaskEither.right(Ouroboros_Models_Core_Ok.ok);
                };
                return Ouroboros_Services_FFI_TaskEither.left(serverError(Ouroboros_Services_FFI_Http.responseStatus(response)));
            });
        }
    };
};
export {
    createDefaultPaymentClient
};
//# sourceMappingURL=index.js.map
